import React, {useState} from "react";
import {ChangePasswordAPI, ForgotPasswordAPI} from "../../services";
import ConfirmCode from "../../components/features/ConfirmCode";
import {Link} from "react-router-dom";
import { Toastify } from "../../components/utils";
import { LanguageLoader } from '../../assets/languages';
import { useSelector } from "react-redux";

const ForgotPassword = () =>
{
    const preferences = useSelector((state) => state.preferences);	
	const language = LanguageLoader(preferences.language);
    const [step, SetStep] = useState(1);
    const [username, SetUsername] = useState('');
    const [confirmCode, SetConfirmCode] = useState('');
    const [password, SetPassword] = useState('');
    const [passwordRepeat, SetPasswordRepeat] = useState('');

    const SendRegisterCode = async () =>
    {
        try {
            const data = { username: username };
            const APIResponse = await ForgotPasswordAPI(data);
            if (APIResponse.sent && APIResponse.encrypted_code.length)
            {
                SetConfirmCode(APIResponse.encrypted_code);
                SetStep(step + 1);
            }
        }
        catch (ex) {}
    }

    const SavePassword = async () =>
    {
        if (password !== passwordRepeat)
        {
            Toastify(language.ERROR.PASSWORD_AND_REPEATED_PASSWORD_MISMATCHED);
        }
        else
        {
            try {
                const tenant = localStorage.getItem("utype");
                const data = { username: username, password: password, utype: tenant, }
                const APIResponse = await ChangePasswordAPI(data);
                if (APIResponse.token !== '')
                {
                    const newToken = APIResponse.token;
                    localStorage.setItem("token", newToken);
                    window.location.replace('/');
                }
            }
            catch (ex) {}
        }
    }

    return (
        <React.Fragment>
            <h2 className="text-secondaryFont text-center mt-14 absolute inset-x-0 -top-40">{language.AUTHENTICATION.FORGOT_PASSWORD_TITLE}</h2>
            {step === 1 ?
            <React.Fragment>
                <h6 className="mb-4">{language.AUTHENTICATION.INSERT_USERNAME}</h6>
                <input type="text" placeholder={language.AUTHENTICATION.USERNAME} required onChange={(e) => SetUsername(e.target.value)}/>
                <div className="mt-14 text-center">
                    <button className="btn-primary w-full" onClick={SendRegisterCode}>{language.AUTHENTICATION.SEND_CONFIRM_CODE}</button>
                    <Link to="/login"><button className="btn-primary w-full secondary">{language.AUTHENTICATION.RETURN}</button></Link>
                </div>
            </React.Fragment>
            : step === 2 ?
            <ConfirmCode callback={() => SetStep(step + 1)}  encryptedOTP={confirmCode} confirmCode={confirmCode} prevStep={() => SetStep(step - 1)}></ConfirmCode>
            : step === 3 ?
            <React.Fragment>
                <h6 className="mb-4">{language.AUTHENTICATION.INSERT_NEW_PASSWORD}</h6>
                <input type="password" placeholder={language.AUTHENTICATION.NEW_PASSWORD} required onChange={(e) => SetPassword(e.target.value)}/>
                <input type="password" className="mt-4" placeholder={language.AUTHENTICATION.NEW_PASSWORD_REPEAT} required onChange={(e) => SetPasswordRepeat(e.target.value)}/>
                <div className="mt-14">
                    <button className="w-full btn-primary" onClick={SavePassword}>{language.AUTHENTICATION.SAVE}</button>
                    <button className="btn-primary w-full secondary" onClick={() => SetStep(step - 1)}>{language.AUTHENTICATION.RETURN}</button>
                </div>
            </React.Fragment>
            : null}
        </React.Fragment>
    )
}

export default ForgotPassword;
